import { Link } from 'react-router-dom'

export default function HelpButton({ fixed = false }) {
  return (
    <Link to="/guide" title="User Guide"
      className={`w-9 h-9 rounded-xl flex items-center justify-center transition-all flex-shrink-0 ${fixed ? 'fixed top-4 right-16 z-50' : ''}`}
      style={{ background: 'var(--surface)', border: '1px solid var(--border-2)', color: 'var(--text-2)' }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--brand)'; e.currentTarget.style.color = 'var(--brand)' }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border-2)'; e.currentTarget.style.color = 'var(--text-2)' }}
    >
      <svg className="w-5 h-5" viewBox="0 0 16 16" fill="none"
           stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="8" cy="8" r="6.5"/>
        <path d="M6.1 6.2c0-1.1.9-2 1.9-2s1.9.8 1.9 1.8c0 1.2-1.9 1.4-1.9 2.8"/>
        <circle cx="8" cy="11.4" r="0.35" fill="currentColor" stroke="none"/>
      </svg>
    </Link>
  )
}
